// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__NXUG8","control":"Checkout_control__vSrjr","actions":"Checkout_actions__SSoSZ","submit":"Checkout_submit__9P8fN","invalid":"Checkout_invalid__WVaNR"};